import { Trans, useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { Beta, Button } from '@mc/design-system'

import { EpisodeStaticData } from '../../[episodeSlug].page'
import { EpisodeTile } from './EpisodeTile'
import { useEpisodeList } from './hooks/useEpisodeList'
import { EpisodeVideoModalContextProvider } from './EpisodeListVideoContext'

import classes from './EpisodeList.module.scss'
import { EpisodeVideoModal } from './EpisodeVideoModal'
import { trackToggleShowAll } from './events'

const { Row, Column } = Beta

export const EpisodeList = () => {
  const { t } = useTranslation('@mc/next')
  const { course, episode: pageEpisode } = useStaticData<EpisodeStaticData>()
  const { showAll, setShowAll, groupedEpisodes, episodes } = useEpisodeList()

  if (!episodes.length) {
    return <></>
  }

  const toggleButtonCopy = t(
    `episode.episodeList.toggle${showAll ? 'Hide' : 'Show'}`,
  )

  const onToggleShowAll = () => {
    setShowAll(!showAll)
    trackToggleShowAll({
      episodeSlug: pageEpisode.slug as string,
      seriesSlug: course.slug as string,
      copy: toggleButtonCopy,
    })
  }

  return (
    <EpisodeVideoModalContextProvider>
      <div className='mc-mt-10 mc-mb-9 d-flex flex-column'>
        <h3 className='mc-text-h3'>
          <Trans
            ns='@mc/next'
            i18nKey='episode.episodeList.title'
            values={{
              seriesTitle: course.title,
            }}
          />
        </h3>
        <div className='mc-mt-4 mc-mb-5'>
          {groupedEpisodes.map((group, index) => (
            <Row key={index} gutters='compact' justifyContent='start'>
              {group.map((episode) => (
                <Column key={episode.id} size={{ xs: 12, md: 6, lg: 4 }}>
                  <EpisodeTile key={episode.id} episode={episode} />
                </Column>
              ))}
            </Row>
          ))}
        </div>
        {episodes.length > 3 && (
          <div className={`align-self-center ${classes.toggleWrapper}`}>
            <Button kind='secondary' fullWidth onClick={onToggleShowAll}>
              {toggleButtonCopy}
            </Button>
          </div>
        )}
      </div>
      <EpisodeVideoModal />
    </EpisodeVideoModalContextProvider>
  )
}
